<ng-template #detail let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Modal title</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>One fine body&hellip;</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>


<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="search()" #form="ngForm" class="form-validate">
      <div class="row">
        <label for="personalId" class="col-form-label col-auto">เลขประจำตัวประชาชน</label>
        <div class="col-auto">
          <input type="text" class="form-control" id="personalId" [(ngModel)]="personalId" name="personalId" required
                 #personalInput="ngModel">
          @if (personalInput.invalid && (personalInput.dirty || personalInput.touched)) {
            <custom-error *ngIf="personalInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-search me-1"></i>ค้นหาข้อมูล
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>รายละเอียดการค้นหา</caption>
        <thead>
        <tr>
          <th nowrap scope="col">ลำดับ</th>
          <th nowrap scope="col">รายละเอียด</th>
          <th nowrap scope="col">เลขประจำตัวประชาชน</th>
          <th nowrap scope="col">ชื่อ-นามสกุล</th>
          <th nowrap scope="col">แหล่งข้อมูล</th>
          <th nowrap scope="col">รอบการลงทะเบียน</th>
          <th nowrap scope="col">ผู้บันทึกข้อมูล/หน่วยงานบันทึกข้อมูล</th>
          <th nowrap scope="col">วันที่บันทึกข้อมูล</th>
          <th nowrap scope="col">ประเภทการลงทะเบียน</th>
          <th nowrap scope="col">สถานะการลงทะเบียน</th>
        </tr>
        </thead>
        <tbody>
          @for (item of dataList | slice :(page - 1) * pageSize : page * pageSize; let i = $index; track item) {
            <tr>
              <td scope="row">{{ ((page - 1) * pageSize) + (i + 1) }}</td>
              <td class="text-center">
                <a (click)="showDetail(item)" class="text-decoration-none fw-semibold cursor-pointer">
                  <img src="/assets/icons/folder-search2.png" alt="" height="25">
                </a>
              </td>
              <td>{{ item.personalId || '-' }}</td>
              <td>{{ (item.personalData?.fullNameWithoutTitle) || '-' }}</td>
              <td nowrap>{{ item.regSourceDesc || '-' }}</td>
              <td>{{ item.roundDate || '-' }}</td>
              <!--              <td>{{ item.createBy || '' }} {{ item.createOrg?.orgName || '' }} {{ item.createOrg?.province?.name || '' }}</td>-->
              <td>
<!--                @if (item.createOrg) {-->
<!--                  {{ item.createOrg?.orgName || '' }} {{ item.createOrg?.province?.name || '' }}-->
<!--                } @else {-->
                  {{ item.createBy || '' }}
<!--                }-->
              </td>
              <td nowrap class="col-date">{{ (item.createDate | thaidatetime) || '-' }}</td>
              <td>{{ item.regTypeName || '-' }}</td>
              <td>{{ item.regStatusDesc || '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="10">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <ngb-pagination class="d-flex justify-content-end"
                        [(page)]="page"
                        [pageSize]="pageSize"
                        [boundaryLinks]="true"
                        [collectionSize]="dataList.length"/>
      </div>
    </div>
  </div>
</div>
